// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics,logEvent } from "firebase/analytics";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDx_5wiEv9a98rFUpZetYFoS1ZDQYeKKsE",
  authDomain: "nabilalsaadi-3d369.firebaseapp.com",
  projectId: "nabilalsaadi-3d369",
  storageBucket: "nabilalsaadi-3d369.appspot.com",
  messagingSenderId: "606828609386",
  appId: "1:606828609386:web:3b99af3e249fde7bccaf13",
  measurementId: "G-LJJB61QWL0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics, logEvent };